import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getPlatforms(data) {
    return request.get(`/${platform}/platforms`, data)
}

export function deletePlatforms(ids) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/platforms/${ids}`)
}

export function storeOrUpdatePlatform(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/platforms/${data.id}` : `/${platform}/platforms`;
    return request[method](url, data)
}


export function getVideoCookie(data) {
    const url = `/${platform}/videos/cookie`
    return request.get(url, data)
}

export function updateVideoCookie(data) {
    const url = `/${platform}/videos/cookie`
    return request.post(url, data)
}

export function syncVideo(data) {
    const url = `/${platform}/videos/sync`
    return request.get(url, data)
}